import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SPREADSHEET_API_URL } from 'settings';
import type { ITermsReturn } from 'v2/interfaces/terms';
import apiService from 'v2/services/api';

/**
 * Service responsible for controlling `Terms` component.
 *
 * @class TermsService
 */
class TermsService {
  /**
   * @method loadFiscalTerm
   * @return {Observable} an array of `ITermsReturn` with the enabled configs on spreadsheet
   * returned by the API
   */
  public loadFiscalTerm = (): Observable<ITermsReturn> => {
    return apiService.get<ITermsReturn[]>(`${SPREADSHEET_API_URL}/hints/terms`).pipe(
      map(terms => terms.filter(term => term.enabled === true && term.name === 'fiscal_term')),
      map(terms => terms[0])
    );
  };
}

const TermsServiceFactory = new TermsService();
export const termsFactory = TermsServiceFactory;
